import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { SymbolMappingFilterParam } from '../_helpers/symbolMappingFilterSearchParam';
import { SymbolMappingFilterAction } from '../symbolMappingFilter.action';

export const clearSymbolMappingFilterEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(SymbolMappingFilterAction.clearFilter),
  map(() => {
    return RouterAction.removeParam(SymbolMappingFilterParam.name);
  }),
);
